module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_purpose_home_color_orange-d6e69ba576aa6ea32f0d29c5481f0e09.svg";